import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import 'normalize.css';
import './global.css';
import './index.scss';
import App from './App';
import { AppProvider } from './context';
import { Loading } from './components/tools'

import './i18n';

const root = createRoot(document.getElementById('root'));

root.render(
  <Suspense fallback={<Loading />}>
    <AppProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AppProvider>
  </Suspense>
);



